var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalIconDefault({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_63)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C16 23.1634 23.1634 16 32 16H100C108.837 16 116 23.1634 116 32V100C116 108.837 108.837 116 100 116H32C23.1634 116 16 108.837 16 100V32Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5 81.1667V50.8333C85.5 48.45 83.55 46.5 81.1667 46.5H50.8333C48.45 46.5 46.5 48.45 46.5 50.8333V81.1667C46.5 83.55 48.45 85.5 50.8333 85.5H81.1667C83.55 85.5 85.5 83.55 85.5 81.1667ZM58.4167 69.25L63.8333 75.7717L71.4167 66L81.1667 79H50.8333L58.4167 69.25Z",
    fill: "#CCCCCC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_63",
    x: 0,
    y: 0,
    width: 132,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160156 0 0 0 0 0.211953 0 0 0 0 0.3125 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_63"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_63",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(40 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIconDefault);
export default __webpack_public_path__ + "static/media/modal-icon-default.1a9a553ee6127c035834ebe7fb088e37.svg";
export { ForwardRef as ReactComponent };